var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttach({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0002 0H2.00024C0.900244 0 0.000244141 0.9 0.000244141 2V18C0.000244141 19.1 0.900244 20 2.00024 20H14.0002C15.1002 20 16.0002 19.1 16.0002 18V5L11.0002 0ZM2.00024 18V2H10.0002V6H14.0002V18H2.00024ZM12.0002 8V13C12.0002 15.21 10.2102 17 8.00024 17C5.79024 17 4.00024 15.21 4.00024 13V6.5C4.00024 5.03 5.26024 3.86 6.76024 4.01C8.06024 4.14 9.00024 5.33 9.00024 6.64V13H7.00024V6.5C7.00024 6.22 6.78024 6 6.50024 6C6.22024 6 6.00024 6.22 6.00024 6.5V13C6.00024 14.1 6.90024 15 8.00024 15C9.10024 15 10.0002 14.1 10.0002 13V8H12.0002Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttach);
export default __webpack_public_path__ + "static/media/attach.4ffc683bf5b750e91278c80736381afa.svg";
export { ForwardRef as ReactComponent };